import React from 'react';

// Utils
import { SCHEMA_TYPE_MULTI_ENUM, SCHEMA_TYPE_TEXT, SCHEMA_TYPE_YOUTUBE } from '../../util/types';
import {
  isFieldForCategory,
  pickCategoryFields,
  pickCustomFieldProps,
} from '../../util/fieldHelpers.js';

import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionMultiEnumMaybe from './SectionMultiEnumMaybe';
import SectionTextMaybe from './SectionTextMaybe';
import SectionYoutubeVideoMaybe from './SectionYoutubeVideoMaybe';

// 👇 Claves posibles del campo de “nubes”
const CLOUD_FIELD_KEYS = ['cloudExperience', 'salesforceClouds', 'salesforce_clouds', 'sfClouds'];

// 👇 Si es el campo de nubes: cambiamos el título y ocultamos las opciones no seleccionadas
const overrideCloudProps = fieldProps => {
  const id = fieldProps.id || fieldProps.key || fieldProps.name;
  if (CLOUD_FIELD_KEYS.includes(id)) {
    return {
      ...fieldProps,
      // puedes dejar string directo o usar i18n si prefieres
      heading: '¿En qué nubes de Salesforce tienes experiencia?',
      showUnselectedOptions: false,
    };
  }
  return fieldProps;
};

const CustomListingFields = props => {
  const { publicData, metadata, listingFieldConfigs, categoryConfiguration } = props;

  const { key: categoryPrefix, categories: listingCategoriesConfig } = categoryConfiguration;
  const categoriesObj = pickCategoryFields(publicData, categoryPrefix, 1, listingCategoriesConfig);
  const currentCategories = Object.values(categoriesObj);

  const isFieldForSelectedCategories = fieldConfig => {
    const isTargetCategory = isFieldForCategory(currentCategories, fieldConfig);
    return isTargetCategory;
  };

  const propsForCustomFields =
    pickCustomFieldProps(
      publicData,
      metadata,
      listingFieldConfigs,
      'listingType',
      isFieldForSelectedCategories
    ) || [];

  return (
    <>
      <SectionDetailsMaybe {...props} isFieldForCategory={isFieldForSelectedCategories} />
      {propsForCustomFields.map(customFieldProps => {
        const { schemaType, ...fieldProps } = customFieldProps;
        const key = fieldProps.id || fieldProps.key || fieldProps.name;

        if (schemaType === SCHEMA_TYPE_MULTI_ENUM) {
          // 👇 aplicamos el override SOLO a cloudExperience
          return <SectionMultiEnumMaybe key={key} {...overrideCloudProps(fieldProps)} />;
        } else if (schemaType === SCHEMA_TYPE_TEXT) {
          return <SectionTextMaybe key={key} {...fieldProps} />;
        } else if (schemaType === SCHEMA_TYPE_YOUTUBE) {
          return <SectionYoutubeVideoMaybe key={key} {...fieldProps} />;
        }
        return null;
      })}
    </>
  );
};

export default CustomListingFields;
